import parseJwt from '../utils/parseJwt';

class ChurnZeroService {
  constructor() {
    if (typeof window.ChurnZero !== 'undefined') {
      this.churnZeroAvailable = true;
    } else {
      this.churnZeroAvailable = false;
    }
  }

  static _instance;

  static instance() {
    if (!ChurnZeroService._instance) {
      ChurnZeroService._instance = new ChurnZeroService();
    }
    return ChurnZeroService._instance;
  }

  push(data) {
    if (this.churnZeroAvailable) {
      return window.ChurnZero.push(data);
    }
  }

  verify() {
    if (this.churnZeroAvailable) {
      return window.ChurnZero.verify();
    }
  }

  debug() {
    if (this.churnZeroAvailable) {
      return window.ChurnZero.debug();
    }
  }

  loginUser(userID, firstName, lastName, organizationID, token) {
    if (this.churnZeroAvailable) {
      window.ChurnZero.push(['setAppKey', import.meta.env.VITE_CHURNZERO_APP_KEY]);
      window.ChurnZero.push(['setContact', organizationID, userID]);
      window.ChurnZero.push(['setAttribute', 'contact', { FirstName: firstName, LastName: lastName }]);
      if (token) {
        const { profile } = parseJwt(token);
        let userRole = '';
        let userEmail = '';

        userEmail = profile.email ? profile.email : '';
        switch (profile.role) {
          case 'Timocco Admin':
          case 'Home Player':
            userRole = '';
            break;
          default:
            userRole = profile.role;
            userRole = profile.is_champion ? `${userRole},Champion` : userRole;
        }

        window.ChurnZero.push(['setAttribute', 'contact', { cf_RestoreContactRole: userRole, Email: userEmail }]);
        window.ChurnZero.push(['setAttribute', 'account', { Name: profile.organization }]);
      }
      window.ChurnZero.push(['trackEvent', 'User Logged In']);
    }
  }

  logoutUser() {
    if (this.churnZeroAvailable) {
      window.ChurnZero.push(['trackEvent', 'User Logged Out']);
      window.ChurnZero.push(['stop']);
    }
  }

  recordGameDuration(gameDuration) {
    if (this.churnZeroAvailable) {
      window.ChurnZero.push([
        'trackEvent',
        'Game Played',
        'Captures duration in minutes the game has been played',
        gameDuration,
      ]);
    }
  }
}

export default ChurnZeroService.instance();
